import React from 'react';
/**
 * @description if
 * @author duanjun
 * @date
 */

interface IIfProps {
    condition: boolean;
    children: React.ReactElement | null;
}

function If(props: IIfProps) {
    if (props.condition) {
        return props.children;
    }
    return null;
}

export default If;
